import { formStyles } from 'styles/formStyles';

export function generateReportPrintUrl(reportName: string, params: { [key: string]: unknown }): string {
    return (
        '/berichte/print/' +
        reportName +
        '?' +
        Object.keys(params)
            .map((key) => {
                const value = params[key];
                if (value === true) {
                    return key + '=true';
                }
                if (value === false) {
                    return key + '=false';
                }
                if (typeof value === 'string') {
                    return key + '=' + encodeURIComponent(value);
                }
                if (typeof value === 'number') {
                    return key + '=' + value;
                }
                return 'key=';
            })
            .join('&')
    );
}

export const getPercent = (value100: number, value: number): number => {
    if (value100 === 0) {
        return 0;
    }
    return value / (value100 / 100);
};

export const getAvg = (values: number[]): number => {
    let sum = 0;
    values.forEach((value) => {
        sum += value;
    });
    return Math.round((sum * 100) / values.length) / 100;
};

export interface GrowthWithColor {
    newValue: number;
    oldValue: number;
    growth: number | undefined;
    color: string;
}

export const getGrowthWithColor = (newValue: number, oldValue: number | undefined): GrowthWithColor => {
    let growth: number | undefined = oldValue ? (newValue * 100) / oldValue - 100 : undefined;
    let color = '';

    if (growth) {
        if (Math.abs(growth) > 100000) {
            growth = undefined;
        }

        if (growth) {
            if (growth > 0) {
                color = formStyles.positiveGrowth;
            } else if (growth < 0) {
                color = formStyles.negativeGrowth;
            }
        }
    }

    return { newValue, oldValue: oldValue || 0, growth, color };
};
